import {
  Alert,
  Button,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import type { SentMomentData } from "../../../../modules/stats/server/analytics-service";
import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

interface PollsAndSurveysData {
  poll_ids: UUID[];
  survey_data: SentMomentData["survey_data"];
}

export const AnalyticsSendsTableExpandedPollsAndSurveys: FC<{
  moment_id: UUID;
  data: PollsAndSurveysData;
}> = ({ moment_id, data }) => {
  const survey_data = data.survey_data ?? [];

  return (
    <Stack spacing={2} direction="column">
      <Typography variant="body2" color="text.secondary">
        This communication contained links to surveys/polls
      </Typography>
      {data.poll_ids.length > 0 && (
        <Alert
          severity="info"
          action={
            <Button
              href={`/moments/${moment_id}/poll_results`}
              target="_blank"
              rel="noopener noreferrer"
              data-analytics-id="view-poll-results"
            >
              View results
            </Button>
          }
        >
          This Communication contained {data.poll_ids.length} poll(s)
        </Alert>
      )}
      {survey_data.length > 0 && (
        <Table>
          <TableHead>
            <TableCell>Surveys linked in this Communication</TableCell>
          </TableHead>
          <TableBody>
            {survey_data.map((survey) => (
              <TableRow key={survey.id}>
                <TableCell>
                  <Link
                    href={`/listen/survey/${survey.id}/results`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-analytics-id="view-survey-results"
                  >
                    {survey.title}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Stack>
  );
};
